export class Lookup {
	$id: number;
	Code: string;
	CodeDescription: string;
	Default: boolean;
	Id: string;
	DF_ID: number;
	Sequence: number;
	StateIdentifier: string;
	State: string;
	UseInReferral: boolean;
	ValidActionCodes: string;
	CodeDesc: string;
	SchoolId: number;
	LastRunByDate: Date;
	LastRunByUser: string;
	SubCodeId: number;
	IncidentCodeId: number;
	IncidentTypeId: number;
	DelStatus: boolean;
	PermissionCategory: string;

	// Non=DTO properties
	IsCritical: boolean;
	IsSelected: boolean;
}

export class SiteLookup {
	Id: number;
	Name: string;
	Code: string;
}

export class DistrictLookup {
	Id: number;
	Name: string;
	ExternalDistrict: boolean;
}

export class HealthLookup {
	Id: number;
	Code: string;
	CodeDescription: string;
	Default: boolean;
}
